import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { HeadingSectionType01Component } from "../../heading-section/heading_section-type01/heading_section-type01.component";
import { Router, RouterLink } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { FuseCardComponent } from '@fuse/components/card';
import {  CarouselAnimationEffect } from '@syncfusion/ej2-angular-navigations';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-services-type01',
  standalone: true,
  imports: [MatIconModule, HeadingSectionType01Component, FuseCardComponent, SlickCarouselModule, NgIf, NgClass, RouterLink],
  templateUrl: './services-type01.component.html',
  styleUrl: './services-type01.component.scss',

})
export class ServicesType01Component implements OnInit, OnDestroy {

  public carouselAnimation: CarouselAnimationEffect = 'Fade';
  public view: any = {
    isMobile: false,
    isTablet: false,
  };
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private _cd: ChangeDetectorRef, 
    private _router: Router, 
    private _tfmService : TFMService,
    private _fuseMediaWatcherService: FuseMediaWatcherService
  ) {  }

  ngOnInit(): void {
    this._tfmService.getSite().then(res => {
      this.view.site = res;
      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
    });

    // Subscribe to media changes for responsive adjustments
    this._fuseMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({matchingAliases}) => {
        this.view.isMobile = !matchingAliases.includes('md');
        this.view.isTablet = matchingAliases.includes('md') && !matchingAliases.includes('lg');
        this._cd.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  slideConfig = {
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
    arrows: true,
    responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
      }
    }
  ]
  };
  
  // addSlide() {
  //   this.slides.push({img: "http://placehold.it/350x150/777777"})
  // }
  
  // removeSlide() {
  //   this.slides.length = this.slides.length - 1;
  // }
  
  slickInit(e) {
    this._tfmService.log('slick initialized');
  }
  
  breakpoint(e) {
    this._tfmService.log('breakpoint');
  }
  
  afterChange(e) {
  }
  
  beforeChange(e) {
  }
}
